import { useEffect, useState } from "react";
import {
  detectArchAsync,
  detectOS,
  type DetectedOS,
} from "../lib/os-detection";

// Synchronous initial detection plus async refinement via UA Client Hints.
// The synchronous detect runs at first render so the button label and the
// OSChooser highlight are correct on first paint; the async refinement
// upgrades confidence (and may flip arm vs x86 on Linux) once the high-
// entropy hints resolve.
export function useDetectedOS(): DetectedOS {
  const [detected, setDetected] = useState<DetectedOS>(() => detectOS());

  useEffect(() => {
    let cancelled = false;
    detectArchAsync(detected).then((refined) => {
      if (cancelled) return;
      // Only update if something actually changed — avoid spurious re-renders.
      if (
        refined.platform !== detected.platform ||
        refined.detectionConfidence !== detected.detectionConfidence
      ) {
        setDetected(refined);
      }
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dev-mode log so we can verify detection in the deployed page console.
  useEffect(() => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.log("[coprocessor-landing] detected OS:", detected);
    }
  }, [detected]);

  return detected;
}
